const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "2026-09-12" -> "12 Sep 2026". Parsed by hand, not with new Date(), so a
// date-only string is never shifted a day by the viewer's timezone.
export function formatDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  const month = MONTHS[Number(m) - 1];
  if (!y || !m || !d || !month) return iso;
  return `${Number(d)} ${month} ${y}`;
}
